<template>

  <v-tooltip v-if="item.payment_id" bottom>
    <template v-slot:activator="{ on }">
      <v-chip
        v-on="on"
        color="green"
        :link=true
        :outlined="true"
        dark
        :to="`/payments/${item.payment_id}`"
        >
          Paid
        <v-icon class="ml-0" right>mdi-currency-usd</v-icon>
      </v-chip>
    </template>
    <span>Go to payment record</span>
  </v-tooltip>
  <v-chip v-else-if="item.is_paid===1" color="green" :outlined="true" dark>Paid</v-chip>
  <v-chip v-else-if="item.is_paid === 0" color="red" :outlined="true" dark>Unpaid</v-chip>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>